var map = {
	"./arrow.svg": 249,
	"./background.png": 250,
	"./background.svg": 251,
	"./crossing.svg": 252,
	"./electricity-big.svg": 253,
	"./electricity-pylon.svg": 254,
	"./electricity-small.svg": 255
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 224;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model nonrecursive \.(svg|png|j(e)?pg)$
// module id = 224
// module chunks = 2 3 5 6